import { FormikHelpers } from "formik";
import { useCreatePlace } from "./api/createPlace";
import PlaceForm from "./PlaceForm";


const CreatePlace = ({handleCloseModal}: CreatePlaceProps)  => {
  const createPlaceMutation = useCreatePlace({data: {}});

  const initialValues: ICreatePlaceForm = {
    description: "",
    deleted: false,
    name: "",
    address: "",
    area_id: "",
    city_id: "",
    zip: 0,
    address_num: "",
    is_emporiki: false,
    is_citi: false
  };

  const handleSubmit = async (values: ICreatePlaceForm, { setSubmitting }: FormikHelpers<ICreatePlaceForm>): Promise<void> => {
    try {
      await createPlaceMutation.mutateAsync({
        data: values,
      });
      handleCloseModal();
    } catch (error) {
      console.log(error);
      console.log("values", values);
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <PlaceForm initialValues={initialValues} type="create" onSubmit={handleSubmit} />
  )
}

interface CreatePlaceProps {
  handleCloseModal: () => void;
}

export default CreatePlace;